import { render, staticRenderFns } from "./frequency.vue?vue&type=template&id=091bbd99&scoped=true"
import script from "./frequency.vue?vue&type=script&lang=js"
export * from "./frequency.vue?vue&type=script&lang=js"
import style0 from "@/utils/style/table.css?vue&type=style&index=0&id=091bbd99&prod&scoped=true&lang=css&external"
import style1 from "./frequency.vue?vue&type=style&index=1&id=091bbd99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091bbd99",
  null
  
)

export default component.exports